import { SxProps, Theme } from '@mui/material';

const styles = {
  container: {
    p: 3,
    maxWidth: 1200,
    mx: 'auto',
    minHeight: '60vh', // Reserve space to prevent layout shift
    width: '100%', // Ensure consistent width
  } as SxProps<Theme>,

  headerSection: {
    mb: 3,
  } as SxProps<Theme>,

  title: {
    fontWeight: 600,
    mb: 1,
  } as SxProps<Theme>,

  subtitle: {
    color: 'text.secondary',
  } as SxProps<Theme>,

  searchSection: {
    mb: 3,
    width: '100%', // Ensure full width
  } as SxProps<Theme>,

  searchInput: {
    width: '100%', // Ensure full width
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    },
  } as SxProps<Theme>,

  loadingContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    py: 2,
    minHeight: 200, // Reserve space to prevent layout shift
  } as SxProps<Theme>,

  errorContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    py: 2,
    minHeight: 100,
  } as SxProps<Theme>,

  errorText: {
    color: 'error.main',
  } as SxProps<Theme>,

  resultsSection: {
    mt: 2,
    width: '100%', // Ensure full width
  } as SxProps<Theme>,

  resultsTitle: {
    mb: 2,
    fontWeight: 500,
  } as SxProps<Theme>,

  noResultsContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    py: 4,
    minHeight: 200,
  } as SxProps<Theme>,

  noResultsText: {
    color: 'text.secondary',
  } as SxProps<Theme>,

  emptyStateContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    py: 4,
    minHeight: 200,
  } as SxProps<Theme>,

  emptyStateText: {
    color: 'text.secondary',
  } as SxProps<Theme>,

  searchIcon: {
    mr: 1,
    color: 'text.secondary',
  } as SxProps<Theme>,

  loadingText: {
    ml: 2,
    color: 'text.secondary',
  } as SxProps<Theme>,

  resultsHeader: {
    mb: 4,
    width: '100%',
  } as SxProps<Theme>,

  resultsHeaderTitle: {
    mb: 1,
    fontWeight: 600,
  } as SxProps<Theme>,

  resultsHeaderSubtitle: {
    mb: 3,
  } as SxProps<Theme>,

  sectionContainer: {
    mb: 4,
    width: '100%',
  } as SxProps<Theme>,

  sectionTitle: {
    mb: 2,
    fontWeight: 500,
  } as SxProps<Theme>,

  noClipsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  } as SxProps<Theme>,

  fallbackHeader: {
    mb: 1,
    fontWeight: 600,
  } as SxProps<Theme>,

  inlineLoading: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  } as SxProps<Theme>,

  suggestionsIntro: {
    mb: 1,
  } as SxProps<Theme>,

  noSuggestionsText: {
    fontStyle: 'italic',
  } as SxProps<Theme>,

  semanticSearchTerms: {
    mb: 1,
  } as SxProps<Theme>,

  collectionsGrid: {
    width: '100%',
  } as SxProps<Theme>,
};

export default styles;
